<template>
    <div class="container">
      <div class="row">
        <div class="col-sm">
          <FixedUnitInput
            :inputLabel="radiusLabel"
            v-model.number="radius"
            :unit="t('units')"
          />
          <FixedUnitInput
            :inputLabel="heightLabel+'*'"
            v-model.number="height"
            :unit="t('units')"
          />
        </div>
        <div class="col-sm">
          <FixedUnitOutput
            :outputLabel="volumeLabel"
            :number="roundedVolume"
            :unit="t('units3')"
          />
        </div>
      </div>
      <i>
       {{ t('CylinderCalcDescription') }}
      </i>
    </div>
  </template>
  
  <script>
  import { ref, computed , reactive, watchEffect} from 'vue';
  import FixedUnitInput from '../inputs/FixedUnitInput.vue'; // Adjust the path as needed
  import FixedUnitOutput from '../inputs/FixedUnitOutput.vue'; // Adjust the path as needed
  import { defaultRound } from '../../utils/math'; // Adjust the import path as needed
  import { useI18n } from 'vue-i18n';
  
  export default {
    name: 'CylinderCalculator',
    components: {
      FixedUnitInput,
      FixedUnitOutput
    },
    setup() {
      const radius = ref(2);
      const height = ref(5);

      const { t } = useI18n();

      const radiusLabel = ref(t('Radius'));
      const heightLabel = ref(t('Height'));
      const volumeLabel = ref(t('Volume'));

      watchEffect(() => {
        radiusLabel.value = t('Radius');
        heightLabel.value = t('Height');
        volumeLabel.value = t('Volume');
      });

      // Create a reactive object with a function
      const translations = reactive({
        t: (key) => t(key)
      })

  
    //   const updateRadius = (val) => {
    //     radius.value = Number(val);
    //   };
  
    //   const updateHeight = (val) => {
    //     height.value = Number(val);
    //   };
  
      const volume = computed(() => {
        return Math.PI * Math.pow(radius.value, 2) * height.value;
      });
  
      const roundedVolume = computed(() => {
        return defaultRound(volume.value);
      });
  
      return { t: translations.t,
        radiusLabel, heightLabel, volumeLabel,
        radius, height, roundedVolume };
    }
  };
  </script>
  